import React, { useState, useEffect, Fragment } from "react";
import PLDeliveryCardDisplay from "./PLDeliveryCardDisplay";
import "./style.css";

const PLDeliveryCard = ({ packingList, deliverPackingList }: any) => {
  const [pawn, setPawn] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState<any>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    priorLoadPawn();
  }, [packingList]);

  const priorLoadPawn = () => {
    setRelatedProducts(null);
    try {
      packingList.pawn.get().then((pawn: any) => {
        const pawnData = pawn.data();
        if (pawnData) {
          setPawn(pawnData);
          priorLoadProducts(pawnData.auction.items);
        } else {
          setError(true);
          console.log("error pawnData", packingList);
        }
      });
    } catch (error) {
      setPawn(packingList.pawn);
      priorLoadProducts(packingList.pawn.auction.items);
    }
  };

  const priorLoadProducts = (items: any) => {
    loadProducts(items).then((prodSnapshots: any) => {
      let products: any = {};
      prodSnapshots.forEach((prodSnap: any) => {
        const product = prodSnap.data();
        products[product.id] = product;
      });
      setRelatedProducts(products);
    });
  };

  const loadProducts = (itemsWithProducts: any) => {
    const promises: any = [];
    let packingListItemsQuantity: any = {};

    Object.keys(itemsWithProducts).forEach((key) => {
      let item = itemsWithProducts[key];
      try {
        promises.push(item.product.get());
      } catch (error) {}
      packingListItemsQuantity[item.id] = 0;
    });

    return Promise.all(promises).catch((error) => {
      alert("Erro ao baixar produtos");
      console.log("erro: ", error);
    });
  };

  return (
    <Fragment>
      <PLDeliveryCardDisplay
        pawn={pawn}
        pawnError={error}
        packingList={packingList}
        relatedProducts={relatedProducts}
        deliverPackingList={deliverPackingList}
      />
    </Fragment>
  );
};

export default PLDeliveryCard;
